import { render, staticRenderFns } from "./SignersMonitor.vue?vue&type=template&id=36b9d8dc&scoped=true&"
import script from "./SignersMonitor.vue?vue&type=script&lang=js&"
export * from "./SignersMonitor.vue?vue&type=script&lang=js&"
import style0 from "./SignersMonitor.vue?vue&type=style&index=0&id=36b9d8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b9d8dc",
  null
  
)

export default component.exports